export interface AnalysisFormProps {
  secondaryInfoNode?: JSX.Element;
  secondaryActionNode?: JSX.Element;
}

export enum AnalysisActionType {
  SAVE = 'save',
  SAVE_UPDATE = 'save_update',
  SAVE_AS = 'save_as',
}
